import { createRegisteredContext } from 'react-singleton-context';
import { noop } from 'lodash';
const SnackbarContext = createRegisteredContext('SnackbarContext', {
  handleMessage: noop
});
export default SnackbarContext;